import { render, staticRenderFns } from "./no-send.vue?vue&type=template&id=44344a0c&scoped=true"
import script from "./no-send.vue?vue&type=script&lang=ts"
export * from "./no-send.vue?vue&type=script&lang=ts"
import style0 from "./no-send.vue?vue&type=style&index=0&id=44344a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44344a0c",
  null
  
)

export default component.exports